import React, { Component } from 'react';
import createStyledComponent from '../utils/createStyledComponent.js';
import * as styles from './styles/index.js';
import { containerStyle } from './styles/common.js';
const SliderWrapper = createStyledComponent(styles);
const ContainerWithValue = createStyledComponent(containerStyle);
class Slider extends Component {
    constructor() {
        super(...arguments);
        this.onChange = (e) => {
            this.props.onChange(parseFloat(e.target.value));
        };
    }
    shouldComponentUpdate(nextProps) {
        return (nextProps.label !== this.props.label ||
            nextProps.value !== this.props.value ||
            nextProps.max !== this.props.max ||
            nextProps.min !== this.props.min ||
            nextProps.withValue !== this.props.withValue ||
            nextProps.disabled !== this.props.disabled);
    }
    render() {
        const { label, sublabel, withValue, theme, ...rest } = this.props;
        const { value, max, min, disabled } = rest;
        const absMax = max - min;
        const percent = ((value - min) / absMax) * 100;
        const slider = React.createElement("input", { ...rest, onChange: this.onChange, type: "range" });
        return (React.createElement(SliderWrapper, { percent: percent, disabled: disabled || absMax === 0, withLabel: !!label, theme: theme },
            label && (React.createElement("label", null,
                label,
                " ",
                sublabel && React.createElement("span", null, sublabel))),
            !withValue ? (slider) : (React.createElement(ContainerWithValue, { theme: theme },
                slider,
                React.createElement("div", null, value)))));
    }
}
Slider.defaultProps = { value: 0, min: 0, max: 100 };
export default Slider;
